import script from "./LinkHandler.vue?vue&type=script&lang=ts&setup=true"
export * from "./LinkHandler.vue?vue&type=script&lang=ts&setup=true"

import "./LinkHandler.vue?vue&type=style&index=0&id=c9f02b9e&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9f02b9e"]])

export default __exports__